/**
 * Project 2026-005 (D-21): guided onboarding gate from API (`User.guidedOnboardingEnabled`),
 * backed by server env `ENABLE_HELP_SYSTEM=true` (see `getCurrentUser`).
 */
export const isGuidedOnboardingEnabled = (user) => (
  user?.guidedOnboardingEnabled === true
);
